import { c as _c } from "react/compiler-runtime";
import { EmptyStatus, EmptyStatusProps, useTranslationContext } from 'platform/components';
import { useIsFilterActive } from '../../store/selectors/useIsFilterActive';
import { useEagGridStore } from '../../store/useEagGridStore';
type DefaultEmptyStateRendererProps = {
  emptyStatus?: Omit<EmptyStatusProps, 'variant'>;
};
export function DefaultEmptyStateRenderer(props) {
  const $ = _c(7);
  const t = useTranslationContext();
  const isFilterActive = useIsFilterActive();
  const store = useEagGridStore();
  let t0;
  if ($[0] !== store) {
    t0 = () => {
      store.deselectAll();
      store.resetFilterValues();
    };
    $[0] = store;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleResetFilters = t0;
  let t1;
  if ($[2] !== handleResetFilters || $[3] !== isFilterActive || $[4] !== props.emptyStatus || $[5] !== t) {
    t1 = isFilterActive ? <EmptyStatus variant="table" headline={t("page.datagrid.labels.emptyDueFilter")} action={{
      title: t("page.datagrid.labels.clearAllFilters"),
      onClick: handleResetFilters
    }} /> : <EmptyStatus variant="table" headline={t("page.datagrid.labels.emptyData")} {...props.emptyStatus} />;
    $[2] = handleResetFilters;
    $[3] = isFilterActive;
    $[4] = props.emptyStatus;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}